<kiene-information-board
    [informationType]="2"
    [headline]="'Wa-Wi Infos'"
    [permissionRead]="4031"
    [permissionWrite]="4032"
    [permissionDelete]="4034"
></kiene-information-board>
